'use strict';

module.exports = function (ngModule) {
    ngModule.config(require('./changelog'));
}


/** WEBPACK FOOTER **
 ** ./src/changelog/routes/index.js
 **/